import axios from 'axios';
import { JsonResponse } from 'core/models/response';
import { CompanySectorsResponse, CompanyTypesResponse } from '../models/companyProfile';

export const getCompanyTypes = async () => {
	try {
		const response = await axios.get<JsonResponse<CompanyTypesResponse>>('register/company-types');
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const getCompanySectors = async () => {
	try {
		const response = await axios.get<JsonResponse<CompanySectorsResponse>>('register/company-sectors');
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const createCompanyProfile = async (data: FormData) => {
	try {
		return await axios.post<JsonResponse<any>>('register/update-company-profile', data, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		});
	} catch (error) {
		throw error;
	}
};
